import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Users, Mail, Building2 } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get("/admin/articles?limit=1"),
      api.get("/admin/leads"),
      api.get("/admin/subscribers"),
      api.get("/admin/contractors"),
    ]).then(([articles, leads, subs, contractors]) => {
      setStats({
        articles: articles.data.total,
        leads: leads.data.length,
        subscribers: subs.data.length,
        contractors: contractors.data.length,
      });
    });
  }, []);

  const cards = [
    { label: "Articles", value: stats?.articles, icon: FileText },
    { label: "Leads", value: stats?.leads, icon: Users },
    { label: "Newsletter Subscribers", value: stats?.subscribers, icon: Mail },
    { label: "Contractors", value: stats?.contractors, icon: Building2 },
  ];

  return (
    <div data-testid="admin-dashboard-page">
      <h1 className="text-2xl font-serif-heading font-bold text-navy mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="bg-white rounded-lg p-5 border border-slate-200" data-testid={`admin-stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <c.icon className="w-6 h-6 text-gold mb-2" />
            <p className="text-2xl font-bold text-navy">{c.value ?? "—"}</p>
            <p className="text-sm text-slate-500">{c.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
